<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <div class="form-group">
          <label
                  for="excmregion_name"
                  class="form-control-label">{{$t('views.excmregion.form.title')}}:</label>
          <input
                  id="excmregion_name"
                  v-model="item.title"
                  :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('title', $event.target.value)">
          <div
                  v-if="isInvalid('name')"
                  class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col>
        <div class="form-group">
          <label
            for="excmregion_name"
            class="form-control-label">{{$t('views.excmregion.form.subtitle')}}:</label>
          <input
            id="excmregion_name"
            v-model="item.subtitle"
            :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
            type="text"
            required="true"
            placeholder=""
            @input="handleUpdateField('subtitle', $event.target.value)">
          <div
            v-if="isInvalid('subtitle')"
            class="invalid-feedback">{{ violations.subtitle }}</div>
        </div>
      </b-col>
      <b-col>
        <div class="form-group">
          <label
            for="excmregionuserdata_idCoordinator"
            class="form-control-label">{{$t('views.excmregion.form.idCoordinator')}}:</label>
          <div class="form-group">
            <base-select-input
              v-model="item.idCoordinator"
              :search-callback="userDataSearchCallback"
              :query-param="'userdata'"
              :display-values="['fullName']"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </div>
          <div
            v-if="isInvalid('userData')"
            class="invalid-feedback">{{ violations.userData }}</div>
        </div>
      </b-col>
    </b-row>
    <template v-if="$route.name === 'EXCMRegionCreate'">
      <b-row v-for="(regionUserDataItem, regionUserDataIndex) in item.regionUserData" v-bind:key="'regionUserDataItem-' + regionUserDataIndex">
        <b-col cols="12" lg="1">
          <h5 class="pt-1 text-center">#{{ regionUserDataIndex + 1 }}</h5>
        </b-col>
        <b-col cols="9" lg="10">
          <div class="form-group">
            <fg-input>
              <el-select
                      class="select-default"
                      :placeholder="$t('views.excmregion.form.userData')"
                      filterable
                      v-model="item.regionUserData[regionUserDataIndex].userData">
                <el-option v-for="option in servicemenOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.name + ' ' + option.surname"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="3" lg="1">
          <b-btn class="btn btn-danger mt-0 float-right" @click="removeRegionUserDataItem(regionUserDataIndex)">
            <span v-if="!mobileView">{{ $t('buttons.delete') }}</span>
            <i v-else class="far fa-trash-alt"></i>
          </b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-btn @click="addRegionUserDataItem()">{{$t('views.excmregion.form.addNewRegionUserData')}}</b-btn>
        </b-col>
      </b-row>
    </template>

    <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import ApiService from '@/utils/ApiService'
export default {
  components: { BaseSelectInput },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      servicemenOptions: []
    }
  },
  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    violations () {
      return this.errors || {}
    }
  },
  created () {
    this.getServicemen()
  },
  methods: {
    getServicemen () {
      let params = {
        'pagination': false,
        'isContractor': 0,
        'state': 1
      }
      this.servicemenOptions = []
      this.$http.get('api/user_datas', {
        params
      })
        .then(response => {
          this.servicemenOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    removeRegionUserDataItem (index) {
      this.item.regionUserData.splice(index, 1)
    },
    addRegionUserDataItem () {
      let item = {
        userData: null
      }
      this.item.regionUserData.push(item)
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 0, state: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
